import { render, staticRenderFns } from "./SImg.vue?vue&type=template&id=08c2e75c&"
import script from "./SImg.vue?vue&type=script&lang=js&"
export * from "./SImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports